var map = {
	"./AdminIcon.svg": 1440,
	"./CreatePaymentIcon.svg": 8136,
	"./CreatePaymentIconActive.svg": 7868,
	"./DataIcon.svg": 6534,
	"./DataIconActive.svg": 39,
	"./EditIcon.svg": 6546,
	"./EditIconActive.svg": 7964,
	"./GeneratePassIcon.svg": 132,
	"./GeneratePassIconActive.svg": 5214,
	"./ReceiptIcon.svg": 3701,
	"./ReceiptIconActive.svg": 6950,
	"./SessionIcon.svg": 5996,
	"./SessionIconActive.svg": 5399,
	"./StatusUserIcon.svg": 5665,
	"./StatusUserIconActive.svg": 9693,
	"./UsersIcon.svg": 3758,
	"./UsersIconActive.svg": 3975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2158;